"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var SavePropertyRemoteAction;
(function (SavePropertyRemoteAction) {
    SavePropertyRemoteAction.SET_SAVE_PROPERTY_IDS_REMOTE = 'SAVE_PROPERTY_REMOTE_SET_SAVE_PROPERTY_IDS_REMOTE';
    SavePropertyRemoteAction.SET_SAVE_PROPERTY_IDS_REMOTE_CHANGED = 'SAVE_PROPERTY_REMOTE_SET_SAVE_PROPERTY_IDS_REMOTE_CHANGED';
    SavePropertyRemoteAction.setSavePropertyIdsRemote = typesafe_actions_1.createAction(SavePropertyRemoteAction.SET_SAVE_PROPERTY_IDS_REMOTE, function (resolve) { return function (savePropertyIds) { return resolve(savePropertyIds); }; });
    SavePropertyRemoteAction.setIsSavePropertyIdsRemoteChanged = typesafe_actions_1.createAction(SavePropertyRemoteAction.SET_SAVE_PROPERTY_IDS_REMOTE_CHANGED, function (resolve) { return function (state) { return resolve(state); }; });
})(SavePropertyRemoteAction || (SavePropertyRemoteAction = {}));
exports.default = SavePropertyRemoteAction;
